import { render, staticRenderFns } from "./hero-doc.vue?vue&type=template&id=bad7e994&"
import script from "./hero-doc.vue?vue&type=script&lang=js&"
export * from "./hero-doc.vue?vue&type=script&lang=js&"
import style0 from "./hero-doc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports